import React from 'react';
import styled from '@emotion/styled';

const LoaderOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

const LoaderSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #4CAF50;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`

const LoaderText = styled.div`
  color: #4CAF50;
  font-size: 1.2rem;
  margin-top: 1rem;
  text-align: center;
`

function Loader({ message = 'Loading...' }) {
  return (
    <LoaderOverlay>
      <div>
        <LoaderSpinner />
        <LoaderText>{message}</LoaderText>
      </div>
    </LoaderOverlay>
  );
}

export default Loader;
